<template>
  <v-app class="grey lighten-4">
    <Navbar></Navbar>
    <v-main class="mx-0 mb-4">
      <router-view></router-view>
    </v-main>
    <v-footer color="blue" dark fixed padless>
      <v-card-text class="py-2 white--text text-center">
        &copy; <strong>Optimus Software</strong> {{ new Date().getFullYear() }}.
        Alle Rechte vorbehalten. (v{{ version }}-{{ env }})
      </v-card-text>
    </v-footer>

    <v-snackbar multi-line top v-model="error">
      <div class="red--text">Fehler:</div>
      <br />
      <div>{{ text }}</div>

      <v-btn @click="error = false" color="red" text> Close </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Navbar from "../components/Navbar";
import { EventBus } from "../eventbus";

export default {
  components: { Navbar },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    error: false,
    text: "",
    version: process.env.VUE_APP_VERSION,
    env: process.env.NODE_ENV,
  }),
  created() {
    EventBus.$on("error", (value) => {
      this.error = true;
      this.text = value;
    });
  },
};
</script>

<style>
#keep .v-navigation-drawer__border {
  display: none;
}
</style>
